import { useQuery } from "@tanstack/react-query";
import { getEventsMetrics } from "../services/events-metrics-service";
import type { EventsMetricsParams } from "../types/events-metrics";

export function useEventsMetrics(params: EventsMetricsParams | null) {
	const enabled =
		!!params?.startDate &&
		!!params?.endDate &&
		params.startDate.length >= 10 &&
		params.endDate.length >= 10;

	return useQuery({
		queryKey: [
			"dashboard",
			"events-metrics",
			params?.startDate,
			params?.endDate,
		],
		queryFn: () => getEventsMetrics(params as EventsMetricsParams),
		enabled,
	});
}
